module.exports = __webpack_public_path__ + "static/will-7fe03690cee2b995aaadd8d06aaa9ef2.png";